import { MANTY_AUTH, WRITE_SCOPES } from 'business/constants';
import { addRoleToRoles, removeRoleFromRoles } from './helpers';
import {
    USER_CREATION_FORM_ACTION_TYPE,
    UserCreationFormAction,
    UserCreationFormState,
} from './types';
import {
    removeBlockValueFromScope,
    removeScope,
    updateScopeAccessType,
    updateScopeBlockValues,
} from './scopeActions';

export const userCreationFormReducer = (
    state: UserCreationFormState,
    action: UserCreationFormAction,
): UserCreationFormState => {
    switch (action.type) {
        case USER_CREATION_FORM_ACTION_TYPE.updateGender:
            return {
                ...state,
                gender: action.gender,
            };
        case USER_CREATION_FORM_ACTION_TYPE.updatePersonalInformation:
            return {
                ...state,
                ...action.payload,
            };

        case USER_CREATION_FORM_ACTION_TYPE.addRole:
            return {
                ...state,
                roles: addRoleToRoles(state.roles, action.role),
            };
        case USER_CREATION_FORM_ACTION_TYPE.removeRole:
            return {
                ...state,
                roles: removeRoleFromRoles(state.roles, action.role),
            };
        case USER_CREATION_FORM_ACTION_TYPE.changeAuthMethod:
            return {
                ...state,
                authMethods: [action.authMethod],
            };
        case USER_CREATION_FORM_ACTION_TYPE.removeScope:
            return removeScope(state, action.scope);
        case USER_CREATION_FORM_ACTION_TYPE.removeWriteScope:
            return removeScope(state, action.writeScope, WRITE_SCOPES);
        case USER_CREATION_FORM_ACTION_TYPE.updateScopeAccessType:
            return updateScopeAccessType(state, action.scope);
        case USER_CREATION_FORM_ACTION_TYPE.updateWriteScopeAccessType:
            return updateScopeAccessType(
                state,
                action.writeScope,
                WRITE_SCOPES,
            );
        case USER_CREATION_FORM_ACTION_TYPE.updateScopeBlockValues:
            return updateScopeBlockValues(
                state,
                action.scope,
                action.blockName,
                action.blockValues,
            );
        case USER_CREATION_FORM_ACTION_TYPE.updateWriteScopeBlockValues:
            return updateScopeBlockValues(
                state,
                action.scope,
                action.blockName,
                action.blockValues,
                WRITE_SCOPES,
            );
        case USER_CREATION_FORM_ACTION_TYPE.removeBlockValueFromScope:
            return removeBlockValueFromScope(
                state,
                action.scope,
                action.blockName,
                action.blockValue,
            );
        case USER_CREATION_FORM_ACTION_TYPE.removeBlockValueFromWriteScope:
            return removeBlockValueFromScope(
                state,
                action.scope,
                action.blockName,
                action.blockValue,
                WRITE_SCOPES,
            );
        default:
            return {
                ...state,
            };
    }
};

export const INITIAL_USER_FORM: UserCreationFormState = {
    authMethods: [MANTY_AUTH],
    email: '',
    firstname: '',
    gender: 'F',
    job: '',
    lastname: '',
    roles: [],
    scopes: [],
    writeScopes: [],
};
